import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PolicyContent from "@/components/PolicyContent";

export default function BookingPolicy() {
  return (
    <div data-testid="policy-page" className="min-h-screen bg-[#FAF8F5] text-[#1C1917]">
      <header className="border-b border-[#1C1917]/10 bg-white/70 backdrop-blur-xl">
        <div className="max-w-2xl mx-auto px-5 sm:px-8 h-16 flex items-center">
          <Link to="/" data-testid="policy-home" className="flex items-center gap-2 text-sm text-[#1C1917]/60 hover:text-[#C5B382] transition-colors">
            <ArrowLeft size={16} /> Back to site
          </Link>
        </div>
      </header>
      <div className="max-w-2xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#C5B382] mb-3">Good to Know</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-medium mb-3">Booking Policy</h1>
        <p className="text-[#1C1917]/55 text-sm mb-10 max-w-lg">
          To keep every appointment running smoothly and fairly, please take a moment to read the policy below before booking.
        </p>
        <PolicyContent />
        <div className="mt-12 border-t border-[#1C1917]/10 pt-6 text-xs text-[#1C1917]/45">
          Questions? Message us on Instagram @slavic.lashes.brows.
        </div>
      </div>
    </div>
  );
}
